export default __webpack_public_path__ + "static/media/animated_glitch_logo.99d84fdd.gif";